export default __webpack_public_path__ + "static/media/yosemite.3b5fc98a.jpg";